import React, { useEffect, useState } from 'react';

const FontSizeAdjuster = () => {
  const [fontSize, setFontSize] = useState(() => {
    const savedSize = sessionStorage.getItem("fontSize")
    return savedSize ? Number(savedSize) : 100
  }); // Tamanho inicial da fonte

  const handleFontSizeChange = (event) => {
    setFontSize(event.target.value);
  };

  useEffect(() => {
    // Atualiza a cor CSS com base nos valores dos sliders
    document.documentElement.style.setProperty(
      '--text-size-dragbox',
      `${fontSize / 100}vw`
    );
    sessionStorage.setItem("fontSize", String(fontSize))
  }, [fontSize]);


  return (
   
   <div>

      <input
        type="range"
        min="100"
        max="200"
        value={fontSize}
        onChange={handleFontSizeChange}
        style={{ width: '100%' }}
        aria-label="Adjust font size"
      />

      <p style={{ fontSize: `${fontSize / 100}vw` }}>
        Ajuste o tamanho da fonte movendo o slider.
      </p>

    </div>
  );
};

export default FontSizeAdjuster;
